<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="bg-gray-50">
    <!-- 顶部导航 -->
    <header class="bg-white shadow-sm rounded-lg">
      <div class="mx-auto px-4 h-16 flex items-center justify-between">
        <div class="flex items-center space-x-2">
          <a-icon type="shopping" class="fas fa-toolbox text-2xl text-blue-600"/> 
          <h1 class="text-xl font-medium">我的工具箱</h1>
        </div>
        <div class="flex items-center space-x-4">
        </div>
      </div>
    </header>
    <!-- 分类导航 -->
    <div class="mx-auto  mt-6">
      <div class="flex space-x-4">
        <a-tag v-for="(tag, index) in tags" :key="index" :class="{ 'bg-blue-50 text-blue-600': activeTag === tag }"
          class="px-4 py-2 cursor-pointer hover:bg-gray-50" @click="changeTag(tag)">
          {{ tag }}
        </a-tag>

        <a-button  type="primary" class="!rounded-button whitespace-nowrap" @click="showAddModal = true" style="height: 38px;">
          + 添加工具
        </a-button>
      </div>
    </div>
    <!-- 工具卡片区域 -->
    <div class="mx-auto  mt-6 pb-8">
      <a-spin :spinning="loading">
        <div class="grid grid-cols-6 gap-4">
          <div v-for="(tool, index) in filteredTools" :key="index"
            class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
            <div class="relative p-4">
              <div class="absolute top-4 right-4" v-if="tool.is_user_tool">
                  <a-dropdown>
                    <template #overlay>
                      <a-menu>
                        <!-- <a-menu-item key="1" @click="editTool(tool)">编辑</a-menu-item> -->
                        <a-menu-item key="2" @click="deleteTool(tool)">删除</a-menu-item>
                      </a-menu>
                    </template>
                    <a-icon type="more" class="text-gray-400 cursor-pointer"/>
                  </a-dropdown>
              </div>
              <div class="flex items-center space-x-3 mb-3">
                <img :src="tool.image" class="w-12 h-12 rounded-lg object-cover" />
                <div>
                  <h3 class="font-medium">{{ tool.name }}</h3>
                  <p class="text-sm text-gray-500 text-left">{{ tool.category }}</p>
                </div>
              </div>
              <p class="text-sm text-gray-600 mb-4 text-left">{{ tool.description }}</p>
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2">
                  <a-icon type="clock-circle" />
                  <span class="text-sm text-gray-500">已用用户：{{ tool.useCount }}</span>
                </div>
                <a-button type="primary" class="!rounded-button" @click="launchTool(tool)">
                  打开
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
    <!-- 添加工具模态框 -->
    <a-modal :visible="showAddModal" title="添加工具" @ok="handleAddTool" @cancel="showAddModal = false"
      :okText="'确定'" :cancelText="'取消'" :confirmLoading="addLoading">
      <a-form :model="newTool" layout="vertical">
        <a-form-item label="链接地址">
          <a-input v-model="newTool.url" />
        </a-form-item>
      </a-form>
    </a-modal>

    <RoiCalculator :discount_lower_price="9.9" :commission_rate="50" :return_rate="10"  v-if="roiCalculatorVisible" @closeRoiVisible="roiCalculatorVisible=false"/>
    <RoiShopCalculator :discount_lower_price="15.8" :commission_rate="6" :return_rate="10"  v-if="roiShopCalculatorVisible" @closeRoiVisible="roiShopCalculatorVisible=false"/>
   
    <a-modal :visible="urlVisible" title="添加工具" @ok="handleAddTool" @cancel="urlVisible = false" :footer="null" width="95%" height="95%">
      <iframe
        src="https://chat.deepseek.com/"
        width="100%"
        height="500px"
        frameBorder="0"
        title="example"
      />
    </a-modal>

    
    <RemoveWatermark  v-if="removeWatermarkVisible" @close="removeWatermarkVisible=false" @copyWatermark="copyWatermark"  />


  </div>
</template>
<script>

import RoiCalculator from "./components/roi.vue"
import RoiShopCalculator from "./components/roishop.vue"
import RemoveWatermark from "./components/removeWatermark.vue"
import { qcApi, requestHttp } from '@utils/index'
import { message, Modal } from 'ant-design-vue'

export default {
  name: 'Tools',
  
  components: {
    RoiCalculator,
    RoiShopCalculator,
    RemoveWatermark
  },
  
  data() {
    return {
      loading: false,
      addLoading: false,
      tags: ['全部',  '计算工具', '视频工具', 'AI工具', '营销工具'],
      activeTag: '全部',
      searchText: '',
      showAddModal: false,
      urlVisible: false,
      roiCalculatorVisible: false,
      removeWatermarkVisible: false,
      roiShopCalculatorVisible: false,
      tools: [],
      newTool: {
        url: ''
      }
    }
  },
  
  created() {
    this.fetchToolList()
  },
  
  computed: {
    filteredTools() {
      let filtered = this.tools;
      // if (this.activeTag !== '全部') {
      //   filtered = filtered.filter(tool => tool.category === this.activeTag);
      // }
      if (this.searchText) {
        filtered = filtered.filter(tool =>
          tool.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
          tool.description.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      return filtered;
    }
  },
  
  methods: {
    copyWatermark(str){
      // this.removeWatermarkVisible=false
      navigator.clipboard.writeText(str)
        .then(() => {
          alert('复制成功，请粘贴到浏览器地址栏中访问视频！')
        })
        .catch(err => {
          this.$message.error({
            content: '复制失败',
            className: 'custom-message', // 自定义类名
            style: {
              zIndex: 10001 // 直接设置样式
            }
          });
        }); 
    },
    changeTag(tag){
      this.activeTag = tag
      this.fetchToolList()
    },
    async fetchToolList() {
      try {
        this.loading = true
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.GET_TOOL_LIST}`,
          method: 'POST',
          params: {
            type: this.activeTag
          }
        })
        if (code == 0) {
          this.$message.error(msg)
          return
        }
        this.tools = data.list
      } catch (error) {
        message.error('获取工具列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    onSearch(value) {
      this.searchText = value
    },
    
    async handleAddTool() {
      try {
        this.addLoading = true
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.ADD_TOOL_BOX}`,
          method: 'POST',
          params: this.newTool
        })
        if (code == 0) {
          this.$message.error(msg)
          return
        }
        message.success('添加工具成功')
        this.showAddModal = false
        this.fetchToolList()
      } catch (error) {
        message.error('添加工具失败')
        console.error(error)
      } finally {
        this.addLoading = false
      }
    },
    
    editTool(tool) {
      // 实现编辑功能
    },
    
    async deleteTool(tool) {
      const that = this;
      Modal.confirm({
        title: '确认删除',
        content: `确定要删除工具"${tool.name}"吗？`,
        okText: '确定',
        cancelText: '取消',
        async onOk() {
          try {
            that.loading = true
            const { code, msg, data } = await requestHttp({
              api: `${qcApi.DEL_TOOL_BOX}`,
              method: 'POST',
              params: {
                id: tool.id,
              },
            });
            if (code == 0) {
              message.error(msg);
              return;
            } 
            message.success('删除工具成功')
            that.fetchToolList()
          } catch (error) {
            message.error('删除工具失败')
            console.error(error)
          } finally {
            that.loading = false
          }
        },
      });
    },
    
    async launchTool(tool) {
      try {
        // 调用点击工具接口
        const { code, msg,data } = await requestHttp({
          api: `${qcApi.CLICK_TOOL_BOX}`,
          method: 'POST',
          params: {
            id: tool.id
          }
        })
        if(code == 0) {
          this.$message.error(msg)
          return
        }
        
        // 打开工具
        if(tool.type === 'tool'){
          if(tool.url === 'watermark'){
            this.removeWatermarkVisible = true
          }else if(tool.url === 'roi'){
            this.roiCalculatorVisible = true
          }else if(tool.url === 'roishop'){
            this.roiShopCalculatorVisible = true
          }
        }else if(tool.type === 'url'){
          window.open(tool.url)
        }
        tool.useCount++
      } catch (error) {
        message.error('打开工具失败')
        console.error(error)
      }
    }
  }
}
</script>
<style scoped>
.ant-tag {
  margin-right: 0;
  border: 1px solid #e5e7eb;
}

.ant-input-search-button {
  height: 100%;
  border-start-end-radius: 0.5rem !important;
  border-end-end-radius: 0.5rem !important;
}
.mainContent {
  background: none !important;
}

</style>